export const COVER_BACK = 'backCover';
export const COVER_BACK_INSIDE = 'insideBackCover';
export const COVER_FRONT = 'frontCover';
export const COVER_FRONT_INSIDE = 'insideFrontCover';
export const SPINE = 'spine';
